export function createSafeStyledView<TView>(View: TView) {
  // Do nothing by default
  return View;
}
